// Search
export const UPDATE_LOADER = "UPDATE_LOADER";

export const GET_SEARCH_PARAMS = "GET_SEARCH_PARAMS";
export const GET_SEARCH_RES = "GET_SEARCH_RES";
export const UPDATE_BUS = "UPDATE_BUS";
export const UPDATE_FILTER_TIME = "UPDATE_FILTER_TIME";
export const UPDATE_FILTER_COACH = "UPDATE_FILTER_COACH";
export const UPDATE_FILTER_JOURNEY_TYPE = "UPDATE_FILTER_JOURNEY_TYPE";
export const UPDATE_FILTER_AMEN = "UPDATE_FILTER_AMEN";
export const UPDATE_FILTER_BUS_SERVICE = "UPDATE_FILTER_BUS_SERVICE";
export const UPDATE_FILTER_RESET = "UPDATE_FILTER_RESET";
export const UPDATE_SEAT_CHART = "UPDATE_SEAT_CHART";
export const UPDATE_SEAT_CHART_DET = "UPDATE_SEAT_CHART_DET";
export const UPDATE_SORT_BY = "UPDATE_SORT_BY";
export const UPDATE_TRIP_DET = "UPDATE_TRIP_DET";

export const GET_RETURN_SEARCH_RES = "GET_RETURN_SEARCH_RES";
export const UPDATE_RETURN_BUS = "UPDATE_RETURN_BUS";



export const UPDATE_LEVY_CONCESSION = "UPDATE_LEVY_CONCESSION";

export const UPDATE_CHECKOUT_DET = "UPDATE_CHECKOUT_DET";
export const UPDATE_USER_NAME = "UPDATE_USER_NAME";
export const UPDATE_USER_AGE = "UPDATE_USER_AGE";
export const UPDATE_USER_GENDER = "UPDATE_USER_GENDER";

export const UPDATE_USER_CONCESSIONTYPE = "UPDATE_USER_CONCESSIONTYPE";
export const UPDATE_USER_IDCARDNO = "UPDATE_USER_IDCARDNO";
export const UPDATE_USER_IDCARDTYPE = "UPDATE_USER_IDCARDTYPE";
export const UPDATE_USER_NATIONALITY = "UPDATE_USER_NATIONALITY";

export const UPDATE_COUPON_LIST = "UPDATE_COUPON_LIST";
export const UPDATE_HEADER_TEXT = "UPDATE_HEADER_TEXT";
export const UPDATE_MIDDLE_ROUTE = "UPDATE_MIDDLE_ROUTE";
export const UPDATE_SERVICE_TYPE_FILTER = "UPDATE_SERVICE_TYPE_FILTER";
export const UPDATE_SEATCHART_ERROR_MSG = "UPDATE_SEATCHART_ERROR_MSG";
export const UPDATE_PATH_DTLS = "UPDATE_PATH_DTLS";
export const UPDATE_ROUTECODE_DTLS = "UPDATE_ROUTECODE_DTLS";
export const UPDATE_BUS_SERVICE_TYPE = "UPDATE_BUS_SERVICE_TYPE";
export const UPDATE_ROUTES_PKPDRP = "UPDATE_ROUTES_PKPDRP";
export const UPDATE_FILTER_BOARDING_POINT = "UPDATE_FILTER_BOARDING_POINT";
export const UPDATE_FILTER_DROPPING_POINT = "UPDATE_FILTER_DROPPING_POINT";
export const UPDATE_FARE_RANGE = "UPDATE_FARE_RANGE";
export const UPDATE_FILTER_PRICE = "UPDATE_FILTER_PRICE";
export const UPDATE_FILTER_LAYOVER = "UPDATE_FILTER_LAYOVER";

export const UPDATE_ORDER_TOKEN = "UPDATE_ORDER_TOKEN";
export const UPDATE_CONTACT_DETAIL = "UPDATE_CONTACT_DETAIL";
export const UPDATE_TRIP_CODE = "UPDATE_TRIP_CODE";
export const UPDATE_SHOW_PASSENGER = "UPDATE_SHOW_PASSENGER";

export const UPDATE_PNR_ENQUIRY_DATA = "UPDATE_PNR_ENQUIRY_DATA";

export const UPDATE_PNR_ENQUIRY_TRIPDATA = "UPDATE_PNR_ENQUIRY_TRIPDATA";

export const UPDATE_LOGIN_DATA = "UPDATE_LOGIN_DATA";

export const UPDATE_BUS_IMAGE = "UPDATE_BUS_IMAGE";
export const UPDATE_CAPTCHA_TOKEN = "UPDATE_CAPTCHA_TOKEN";
export const UPDATE_SATATIC_CITY_LIST = "UPDATE_SATATIC_CITY_LIST";
export const UPDATE_CITY_LIST = "UPDATE_CITY_LIST";

export const UPDATE_PACKAGE_DATA = "UPDATEPACKAGEDATA";
export const UPDATE_PACKAGE_CITY = "UPDATEPACKAGECITY";
export const UPDATE_PACKAGE_CATEGORY = "UPDATEPACKAGECATEGORY";
export const UPDATE_PACKAGE_TOUR = "UPDATEPACKAGETOUR";


export const UPDATE_LINKED_CITY_DATA = "UPDATE_LINKED_CITY_DATA";




